module.exports = __webpack_public_path__ + "img/us-5.dcc18d41.png";